/** https://aletheia-beta.shepherdtech.group/api/doc#/Events/EventsController_trackStandardEvent */
export const aletheiaSalesEventNameSet = new Set<string>([
  'add_to_cart',
  'add_to_wishlist',
  'begin_checkout',
  'view_item',
  'view_item_list',
  'page_view',
])
/** https://docs.google.com/spreadsheets/d/1aHB780NfzPiVW5Key62S4FcXA8xxo4uYZvs11QjR8YQ/edit?gid=105553383#gid=105553383 */
export const aletheiaCouponEventNameSet = new Set<string>([
  'check_coupon_tags',
  'check_coupon_list',
  'open_coupon_dialog',
  'open_sitewide_discount_process_bar',
  'achieve_all_sitewide_discount',
  'click_coupon_card',
  'click_coupon_page_banner',
  'open_gift_description',
  'check_gift_critertion',
  'check_AnB_tab',
  'open_footer_cart',
  'hide_footer_cart',
])

export const aletheiaCustomEventNameSet = new Set<string>([
  'adjust_quantity',
  'remove_from_cart',
])

export const aletheiaLineLiffEventNameSet = new Set<string>([
  'click_start_play_wheel',
  'click_go_points_center_btn',
  'click_copy_coupon_btn',
  'click_reward_acknowledge_btn',
  'click_use_coupon_link',
])

export const aletheiaEndpointConfigs = [
  { set: aletheiaSalesEventNameSet, endpoint: '' },
  { set: aletheiaCouponEventNameSet, endpoint: '/coupon-event' },
  { set: aletheiaCustomEventNameSet, endpoint: '/custom-event' },
  { set: aletheiaLineLiffEventNameSet, endpoint: '/line-liff-event' },
]
